export default __webpack_public_path__ + "static/media/wceconnects.1c13f1b2.png";